export default "__VITE_ASSET__G41P0fS1__"